import { mapUserFromDTO } from '@entities/user/api/mappers'
import type { Token, TokenDTO } from '../model/types'
import type { CreateTokenArgs, CreateTokenArgsDTO } from './types'

export const mapTokenFromDTO = ({ id, token, creator, title, channel }: TokenDTO): Token => ({
    id,
    token,
    creator: mapUserFromDTO(creator),
    title,
    channel
})

export const mapCreateTokenArgsToDTO = ({ title, channel }: CreateTokenArgs): CreateTokenArgsDTO => ({
    title,
    channel
})
